export default function initClick() {
  jQuery('#scroll-email').on('click', function () {
    jQuery('#email-want').focus();
  })
}
